import { render, staticRenderFns } from "./1V1.vue?vue&type=template&id=05cff4a3&scoped=true"
import script from "./1V1.vue?vue&type=script&lang=js"
export * from "./1V1.vue?vue&type=script&lang=js"
import style0 from "./1V1.vue?vue&type=style&index=0&id=05cff4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cff4a3",
  null
  
)

export default component.exports